const HOSTED_PRIXI_LOGO_URL =
  "https://prixi.cl/prixi-logo.png";

/** Public Prixi wordmark for invite header (local asset with hosted fallback). */
export function getPrixiLogoSrc(): string {
  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  if (base) {
    return `${base}/prixi-logo.png`;
  }
  return HOSTED_PRIXI_LOGO_URL;
}
